import React from 'react';
import { Form } from 'react-bootstrap';
import '../css/AdminSwitches.css';

export default function ModeSwitch({ id, label, left, right, checked, onChange }) {
  return <div className="admin-mode-switch d-flex align-items-center gap-2 mb-3" role="group" aria-label={label}>
    <span className={!checked ? 'fw-semibold' : 'text-muted'}>{left}</span>
    <Form.Check type="switch" role="switch" className="admin-switch m-0" id={id} aria-label={`${left} / ${right}`}
      checked={checked} onChange={(event) => onChange(event.target.checked)} />
    <span className={checked ? 'fw-semibold' : 'text-muted'}>{right}</span>
  </div>;
}
